import type { OwlLeg } from "../../owl/useOwlHourSlips.ts";
export function owlTeams(leg: Pick<OwlLeg, "home" | "away" | "match_name">): [string, string] {
  const parsed = leg.match_name?.split(/\s+(?:vs?\.?)\s+/i);
  return [
    leg.home?.trim() || parsed?.[0]?.trim() || "Home team unavailable",
    leg.away?.trim() || parsed?.[1]?.trim() || "Away team unavailable",
  ];
}
export function owlKickoff(raw: string): string {
  if (!raw) return "Kickoff not available";
  if (/^\d{2}:\d{2}$/.test(raw)) return `${raw} Accra`;
  const date = new Date(raw);
  if (!Number.isFinite(date.getTime())) return raw;
  return (
    new Intl.DateTimeFormat("en-GB", {
      timeZone: "Africa/Accra",
      day: "numeric",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(date) + " Accra"
  );
}
export function owlPublicNote(note: string): string {
  return !note ||
    /substrate|\bclv\b|lambda|poisson|desk.anchored|edge\s*[+:=]|multiplier/i.test(note)
    ? "Published selection. Check current availability and the exact market before acting."
    : note;
}
export function owlSelection(leg: OwlLeg): string {
  const [home, away] = owlTeams(leg);
  const side = leg.selection.toLowerCase().trim();
  if (side === "home") return home;
  if (side === "away") return away;
  if (side === "draw") return "Draw";
  return (
    leg.selection
      .replace(/^over_(\d+)_(\d+)$/i, "Over $1.$2")
      .replace(/^under_(\d+)_(\d+)$/i, "Under $1.$2") || "Selection unavailable"
  );
}
